import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  updateCateringSelection
} from "../../../store/checkoutSlice";

const CateringItemCard = ({ item,eventId,provider, isCheckout }) => {

   const dispatch = useDispatch();

   
  const [selectedPct, setSelectedPct] = useState(100);

  const hasDiscount =
    item.discounted_price > 0 &&
    item.discounted_price < item.regular_price;




  const handleSelect = (value) => {
    if (selectedPct === value) {
      if (!window.confirm("Remove item and order later?")) return;
      setSelectedPct(null);
    } else {
      setSelectedPct(value);
    }

    // 👉 connect redux here
    dispatch(updateCateringSelection({ eventId, percentage: value }))
  };


  return (
    <div className="item-card">

      {/* ITEM INFO */}
      <p>
        {item.meal?.name} • {item.number_of_people} Guests
      </p>

      {/* PRICE */}
      {hasDiscount ? (
        <>
          <p style={{ textDecoration: "line-through" }}>
            ₹{item.regular_price}
          </p>
          <p>₹{item.discounted_price}</p>
        </>
      ) : (
        <p>₹{item.regular_price}</p>
      )}

      <p>GST: ₹{item.gst_amount}</p>
      <p>Total: ₹{item.total_amount}</p>

      {/* PAYMENT OPTIONS */}
      {isCheckout && (
        <div>
          <label>
            <input
              type="radio"
              checked={selectedPct === 100}
              onChange={() => handleSelect(100)}
            />
            Full
          </label>

          <label>
            <input
              type="radio"
              checked={selectedPct === 25}
              onChange={() => handleSelect(25)}
            />
            25%
          </label>

          <label>
            <input
              type="radio"
              checked={selectedPct === 10}
              onChange={() => handleSelect(10)}
            />
            10%
          </label>
        </div>
      )}

      {/* PAYMENT STATUS */}
      <p>
        {provider.balance_to_be_paid > 0
          ? `Pending ₹${provider.balance_to_be_paid}`
          : "Fully Paid"}
      </p>

      {/* TO PAY */}
      {isCheckout && selectedPct !== null && (
        <p>
          To Pay: ₹{provider.paymentSummary?.payable_now || 0}
        </p>
      )}
    </div>
  );
};

export default CateringItemCard;